import { change } from 'redux-form';

const compareVersions = require('compare-versions');

export const getIn = (path, o) =>
  path.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);

const getReleaseVersionsByDeviceType = (
  releaseVersion = [],
  type = '',
  osVersion = ''
) => {
  return releaseVersion
    .filter(v => v.deviceType === type)
    .filter(v => v.osVersion === osVersion);
};

const getReleaseVersionsByDeviceSubType = (
  releaseVersion = [],
  subType = '',
  osVersion = ''
) => {
  return releaseVersion
    .filter(v => v.deviceSubType === subType)
    .filter(v => v.osVersion === osVersion);
};

export const getSWVersion = (
  releaseVersion = [],
  type = '',
  subType = '',
  osVersion = ''
) => {
  let allAvailableVersions = [];
  // check if device has subType
  // if not, then it it likely DES
  if (!subType || subType === 'None') {
    // parse available versions using deviceType
    allAvailableVersions = getReleaseVersionsByDeviceType(
      releaseVersion,
      type,
      osVersion
    );
  } else {
    // device has subType, try to parse release versions using subType
    allAvailableVersions = getReleaseVersionsByDeviceSubType(
      releaseVersion,
      subType,
      osVersion
    );
    // if releases can't be found using subType, fallback to deviceType
    if (
      !Array.isArray(allAvailableVersions) ||
      allAvailableVersions.length === 0
    ) {
      allAvailableVersions = getReleaseVersionsByDeviceType(
        releaseVersion,
        type,
        osVersion
      );
    }
  }

  //check if default release version available
  const defaultVersion = allAvailableVersions.find(
    version => version.isDefaultReleaseVersion
  );

  // if there is a valid default version, send that version as releaseTagVersion
  if (
    defaultVersion &&
    compareVersions.validate(defaultVersion.releaseTagVersion)
  ) {
    return defaultVersion.releaseTagVersion;
  }

  // if no defaultReleaseVersion found
  // OR
  // if the defaultReleaseVersion is not valid
  // return the latest valid version
  const versions = allAvailableVersions
    .map(v => v.releaseTagVersion)
    .filter(v => compareVersions.validate(v))
    .sort(compareVersions)
    .reverse();

  if (Array.isArray(versions) && versions.length >= 1) {
    return versions[0];
  } else {
    return null;
  }
};

export const toSelectObject = (value, label = '') => ({
  label: label ? label : value,
  value,
});

export const setField = (props, field, value) => {
  props.dispatch(change(props.form, field, value));
};

export const clearField = (props, field) => {
  props.clearFields(props.form, false, false, field);
};
